(function(){
  // setTimeout(() => {
  //   gift_cart_variants();
  // }, 2000);

  // document.addEventListener('ajaxProduct:added', function(e){
  //   console.log('ajaxProduct addition');
  //   setTimeout(() => {
  //     gift_cart_variants();
  //   }, 2000);
  // });
  // document.addEventListener('cart:updated', function(e){
  //   console.log('cart updated ', e);
  //   setTimeout(() => {
  //     gift_cart_variants();
  //   }, 2000);
  // });
  document.addEventListener('cart_gift:updated', function(e){
    console.log('cart updated ', e);
    // setTimeout(() => {
      gift_cart_variants();
    // }, 2000);
  });
  // add collection product to cart
  document.querySelectorAll('.cart_add_btn_x_sell').forEach(item => {
    setAddToCartBtn(item);
  });
  view_upsell_datalayer();
  function setAddToCartBtn(selector){
    if(selector){
        console.log("selector", selector);
        selector.addEventListener("click", () => {
          console.log("selector", selector);
          let variant_id = parseInt(selector.getAttribute('data-variant-id'));
          let hasCartGiftItem = (document.querySelectorAll('[data-gift-cart-item]').length > 0 )? true : false,
              productTags = selector.getAttribute('data-tags'),
              formData = {
                'items': [{
                  'id': variant_id,
                  'quantity': 1,
                  'properties': {'_Upsell': variant_id}
                }]
              };
              console.log("formData:",formData);
              if(selector.classList.contains('cart-xsell-discount-btn') && selector.getAttribute('data-x-sell-discount') != "0"){
                formData.items[0].properties._cart_xsell = selector.getAttribute('data-x-sell-discount');
                formData.items[0].properties._offer_discount = selector.getAttribute('data-x-sell-discount');
              }
              if (!hasCartGiftItem && window.gift && productTags.includes('Free_Shaker')) {
                formData = buildGiftForm(variant_id);
              }
            addProductToCart(variant_id, selector, formData);
            console.log("formData:",formData);
        });
    }
  }

  function buildGiftForm(variant) {
    let formItems =[];
    formItems.push(
      {
        'id': window.gift.giftProduct,
        'quantity': 1
      }
    );
    formItems.push(
      {
        'id': variant,
        'quantity': 1
      }
    );
    
    let formData = {
      'items': formItems
    };
    return formData;
  }


  // add product to cart
  function addProductToCart(variant, cart_add_btn, formData){
    console.log("addProductToCart:",variant);
    if(window.enable_shaker_popup == "true" && variant == window.gift.giftProduct &&  document.querySelector('[data-section-type="shaker-popup"]') != null){
      window.enable_shaker_popup = "false";
      document.cookie = 'ignored_shaker_popup=true;expires=0;path=/';
      window.show_popup = "false";
    }
    if(window.enable_gift_popup == "true" && variant == window.cart_gift?.id &&  document.querySelector('[data-section-type="gift-popup"]') != null){
      window.enable_gift_popup = "false";
      console.log(" gift is already added to cart so ignore it");
      document.cookie = 'ignored_gift_popup=true;expires=0;path=/';
      window.show_popup = "false";
    }
    fetch(theme.routes.cartAdd, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(product => {
      if (product.status === 422){
        return;
      }
      // hide x sell product
      if(window.xSellProduct && variant == window.xSellProduct.xSellId ){
        let xSellWrapper = document.querySelector('.x-sell__wrapper');
        if(xSellWrapper)
          xSellWrapper.style.display = 'none';
      }

      add_upsell_datalayer(product.items[0].title);
      add_to_cart_dataLayer_aftersell(product);
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: {
          product: product,
          addToCartBtn: cart_add_btn
        }
      }));
      if(location.pathname == '/cart' && window.enable_gift_popup != "true" && variant == window.cart_gift?.id){ window.location.href = window.location.href;}

    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }

  function add_upsell_datalayer(product_title){
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: "add_upsell_product",
      item_name: product_title // dynamisch übergeben
    });
  }

  function view_upsell_datalayer(){
    var view_upsell_btns = document.querySelectorAll('.view_x_sell');
    view_upsell_btns.forEach(btn => {
      btn.addEventListener('click', function(e){
        e.preventDefault();
        var product_title = btn.getAttribute('data-product-title');
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: "click_upsell_product",
          item_name: product_title // dynamsich übergeben
        });
        console.log("add data layer", window.dataLayer);
        window.location.href = btn.getAttribute('href');
      });
    });
  }

  function add_to_cart_dataLayer_aftersell(product){
    setTimeout(() => {
      var cart_item_data = document.querySelector("#x_sell_product");
      product = product.items[0];
      let cartTotal = document.querySelector('[subtotal-amount]').getAttribute("subtotal-amount");
      var collection_1 = cart_item_data.getAttribute("data-collection1"),
          collection_2 = cart_item_data.getAttribute("data-collection2"),
          collection_3 = cart_item_data.getAttribute("data-collection3"),
          collection_4 = cart_item_data.getAttribute("data-collection4"),
          collection_5 = cart_item_data.getAttribute("data-collection5");
      let money_datalayer_format = theme.settings.moneyFormat.replace('_with_comma_separator','').replace('CHF ','');

      window.dataLayer = window.dataLayer || [];
      dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
      dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
          'value': cartTotal,
          items: [{
            id: "shopify_CH_" + product.product_id + product.variant_id,
            google_business_vertical: 'retail',
            item_id: product.product_id,                 // item_id or item_name required
            item_name: product.product_title,
            coupon: product.discounts.length > 0 ? product.discounts[0].title: '',
            currency: Shopify.currency.active,
            discount: theme.Currency.formatMoney(product.line_level_total_discount, money_datalayer_format),
            index: 0,
            item_brand: product.vendor,
            item_category:  collection_1,
            item_category2: collection_2,
            item_category3: collection_3,
            item_category4: collection_4,
            item_category5: collection_5,
            item_variant: product.variant_title ? product.variant_title: 'Default',
            price: theme.Currency.formatMoney(product.line_price, money_datalayer_format),
            quantity: product.quantity
          }]
        }
      });
    },1000);
  }

  function gift_cart_variants(){
    console.log("Handle gift variants in the cart ");
    let variants_selectors = document.querySelectorAll("#cart_gift_variants .sort-items__option");
    console.log("variants_selectors:",variants_selectors);
    variants_selectors.forEach(element => {
      element.addEventListener("click", function(){
        if(element.classList.contains("disabled")){
          return;
        }
        console.log("element clicked:",element);

        document.querySelector("#cart_gift_variants").querySelector(".color_name").innerHTML = element.getAttribute("name");
        document.querySelector("#cart_gift_variants").removeAttribute("open");

        let gift_removed_id = parseInt(document.querySelector("#cart_gift_variants").querySelector(".sort-items__option.selected").getAttribute("value"));
        let gift_added_id = parseInt(element.getAttribute("value"));

        document.querySelector("#cart_gift_variants").querySelector(".sort-items__option.selected").classList.remove("selected");
        element.classList.add("selected");

        window.cart_gift.id = gift_added_id;
        localStorage.setItem("Gift_product", gift_added_id);

        gift_update(gift_removed_id, gift_added_id);
      });
    });
  }

  function gift_update(removed_id, added_id){
    let updates = {
      [added_id] : 1,
      [removed_id]: 0
    };
    // console.log("updates arr:", updates);

    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates })
    })
    .then(response => {
      // console.log("response",response);
      return response.json();
    })
    .then(product => {
      // console.log("product:", product);
      if (product.status === 422){
        return;
      }
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: {
          product: product,
          addToCartBtn: null
        }
      }));
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }

}());